"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
exports.PLAYER_ELEMENT_ID = 'ctvframework-video-player-webos';
var MAX_WAIT_AUDIOTRACKS_MS = 5000;
var WebOSPlayer = (function (_super) {
    __extends(WebOSPlayer, _super);
    function WebOSPlayer(context, drmAgent, startingBitrate, isWebOS2) {
        if (isWebOS2 === void 0) { isWebOS2 = false; }
        var _this = _super.call(this) || this;
        _this.context = context;
        _this.drmAgent = drmAgent;
        _this.startingBitrate = startingBitrate;
        _this.isWebOS2 = isWebOS2;
        _this.mediaInfoAudioTracksObservable = new client_lib_js_player_addons_common_player_1.Observable();
        _this.suppressNextPlayEvent = false;
        _this.changedAudioTrack = false;
        _this.onLoadStartHandler = function () {
            if (!_this.currentState) {
                _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Rebuffering);
            }
        };
        _this.onPlayingHandler = function () {
            if (_this.suppressNextPlayEvent) {
                _this.suppressNextPlayEvent = false;
                return;
            }
            _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Playing);
        };
        _this.onPauseHandler = function () {
            _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Paused);
        };
        _this.onWaitingHandler = function () {
            _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Rebuffering);
        };
        _this.onVideoErrorHandler = function (error) {
            _this.raiseErrorAndStop({ code: '', message: error, isFatal: true });
        };
        _this.onFinishHandler = function () {
            _this.notifyCurrentPositionChanged(Math.round(_this.getDuration()));
            _this.notifyDurationChanged(_this.getDuration());
            _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Finished);
        };
        _this.onTimeUpdateHandler = function (ev) {
            var videoCurrentTime = Math.round(_this.videoElement.currentTime);
            if (ev.force ||
                ((_this.currentState !== client_lib_js_player_addons_common_player_1.PlayerState.Finished &&
                    _this.currentState !== client_lib_js_player_addons_common_player_1.PlayerState.Rebuffering &&
                    _this.currentState !== client_lib_js_player_addons_common_player_1.PlayerState.Paused) ||
                    _this.videoElement.currentTime === 0)) {
                _this.notifyCurrentPositionChanged(videoCurrentTime);
                _this.notifyDurationChanged(_this.getDuration());
            }
        };
        _this.onDurationChangeHandler = function () {
            var secondsUntilFinished = _this.videoElement.duration - _this.nativeLoadData.position;
            if (secondsUntilFinished < 1) {
                var source = _this.sourceElement.src;
                _this.destroySourceElement();
                _this.createSourceElement(source, 0);
            }
            else {
                _this.notifyDurationChanged(_this.videoElement.duration);
            }
        };
        _this.onMediaInfoUpdateHandler = function (ev) {
            var mediaInfo = JSON.parse(ev.detail);
            if (mediaInfo.type === 'error') {
                var error = mediaInfo.info
                    ? {
                        code: mediaInfo.info.errorCode,
                        message: mediaInfo.info.errorText,
                        isFatal: true,
                    }
                    : { code: '', message: '', isFatal: true };
                _this.raiseErrorAndStop(error);
            }
            else if (mediaInfo.type === 'videoInfo' && mediaInfo.info) {
                _this.notifyBitrateChanged({
                    bitrateKbps: mediaInfo.info.bitRate,
                    resolution: {
                        width: mediaInfo.info.width,
                        height: mediaInfo.info.height,
                    },
                });
            }
            else if (mediaInfo.type === 'sourceInfo') {
                if (_this.hasAudioTracksFromSourceInfo(mediaInfo)) {
                    _this.mediaInfoAudioTracksObservable.notifyObservers(mediaInfo.info.programInfo[0].audioTrackInfo);
                }
                else {
                    _this.mediaInfoAudioTracksObservable.notifyObservers([]);
                }
            }
        };
        _this.onLoadedMetaData = function () {
            _this.setAudioTrackAfterLoaded().then(function () {
                if (_this.isWebOS2 && _this.nativeLoadData.autoplay) {
                    _this.nativePlay();
                }
            });
        };
        _this.onLoadedData = function () {
            if (_this.isWebOS2 && _this.nativeLoadData.position) {
                _this.videoElement.currentTime = _this.nativeLoadData.position;
            }
        };
        _this.onStalled = function () {
            if (_this.changedAudioTrack) {
                _this.changedAudioTrack = false;
                _this.videoElement.currentTime = _this.videoElement.currentTime - 0.01;
            }
        };
        _this.currentState = client_lib_js_player_addons_common_player_1.PlayerState.Stopped;
        return _this;
    }
    WebOSPlayer.prototype.initialise = function () {
        return Promise.resolve();
    };
    WebOSPlayer.prototype.nativeLoad = function (nativeLoadData) {
        var _this = this;
        this.nativeLoadData = nativeLoadData;
        this.availableAudioTracks = [];
        this.createVideoElement(nativeLoadData);
        this.setPlayoutRect(nativeLoadData.custom && nativeLoadData.custom.playoutRect);
        this.drmAgent
            .initialise(nativeLoadData.drmConfiguration)
            .then(function () {
            _this.loadAsset(nativeLoadData);
        })
            .catch(function (error) {
            _this.raiseErrorAndStop({
                code: (error && error.errorCode) || '-1',
                message: (error && error.errorText) || 'unknown',
                isFatal: true,
            });
        });
    };
    WebOSPlayer.prototype.initiateSeek = function (seconds) {
        if (this.videoElement && typeof seconds === 'number' && !isNaN(seconds)) {
            this.suppressNextPlayEvent = true;
            this.videoElement.currentTime = seconds;
            if (this.currentState !== client_lib_js_player_addons_common_player_1.PlayerState.Playing) {
                if (this.getDuration() - seconds < 1) {
                    this.onFinishHandler();
                }
                else {
                    this.onTimeUpdateHandler({
                        target: this.videoElement,
                        force: true,
                    });
                }
            }
        }
    };
    WebOSPlayer.prototype.nativeStop = function () {
        var _this = this;
        if (this.currentState !== client_lib_js_player_addons_common_player_1.PlayerState.Stopped) {
            if (this.videoElement) {
                if (!this.videoElement.paused) {
                    this.videoElement.pause();
                }
                if (this.videoElement.currentTime) {
                    this.videoElement.currentTime = 0;
                }
            }
            this.dispose().then(function () {
                _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Stopped);
            });
        }
    };
    WebOSPlayer.prototype.nativePause = function () {
        if (!this.videoElement.paused) {
            this.videoElement.pause();
        }
    };
    WebOSPlayer.prototype.nativePlay = function () {
        if (this.currentState !== client_lib_js_player_addons_common_player_1.PlayerState.Playing || this.videoElement.paused) {
            if (!this.videoElement.paused && this.videoElement.playbackRate !== 1) {
                this.videoElement.pause();
            }
            this.videoElement.play();
        }
        this.suppressNextPlayEvent = false;
    };
    WebOSPlayer.prototype.dispose = function () {
        if (this.videoElement) {
            if (this.currentState !== client_lib_js_player_addons_common_player_1.PlayerState.Finished && !this.videoElement.paused) {
                this.nativePause();
            }
            this.removeVideoListeners();
            this.destroySourceElement();
            this.destroyVideoElement();
        }
        return this.drmAgent.close();
    };
    WebOSPlayer.prototype.setPlayoutRect = function (playoutRect) {
        if (!this.videoElement || !this.videoElementWrapper) {
            return;
        }
        var fullScreenRect = this.getFullScreenPlayoutRect();
        var rect = playoutRect || fullScreenRect;
        this.videoElementWrapper.style.position = 'fixed';
        this.videoElementWrapper.style.width = 'width' in rect ? rect.width + "px" : '100%';
        this.videoElementWrapper.style.height = 'height' in rect ? rect.height + "px" : '100%';
        this.videoElementWrapper.style.left = (rect.x || fullScreenRect.x) + "px";
        this.videoElementWrapper.style.top = (rect.y || fullScreenRect.y) + "px";
        this.videoElementWrapper.style.zIndex = "" + ('zIndex' in rect ? rect.zIndex : -1000);
        this.videoElement.width = rect.width || fullScreenRect.width;
        this.videoElement.height = rect.height || fullScreenRect.height;
    };
    WebOSPlayer.prototype.getFullScreenPlayoutRect = function () {
        return {
            x: 0,
            y: 0,
            width: this.context.document.body.clientWidth,
            height: this.context.document.body.clientHeight,
        };
    };
    WebOSPlayer.prototype.nativeSetVolume = function (volume) {
        return;
    };
    WebOSPlayer.prototype.nativeSetAudioTrack = function (trackId) {
        var _this = this;
        this.changeAudioTrack(trackId).then(function (success) {
            if (success) {
                _this.changedAudioTrack = true;
                _this.notifyCurrentAudioTrackChanged(trackId);
            }
        });
    };
    WebOSPlayer.prototype.changeAudioTrack = function (trackId) {
        if (this.isHtmlAudioTracksAvailable()) {
            return this.nativeSetAudioTrackHtmlVideo(trackId);
        }
        else {
            return this.nativeSetAudioTrackLunaApi(trackId);
        }
    };
    WebOSPlayer.prototype.nativeSetAudioTrackHtmlVideo = function (trackId) {
        var nativeAudioTracks = Array.from(this.videoElement.audioTracks);
        var selectedAudioTrack = nativeAudioTracks.find(function (track) { return track.language === trackId; });
        var currentAudioTrack = nativeAudioTracks.find(function (track) { return track.enabled; });
        if (selectedAudioTrack && selectedAudioTrack !== currentAudioTrack) {
            nativeAudioTracks.forEach(function (audioTrack) {
                audioTrack.enabled = false;
            });
            selectedAudioTrack.enabled = true;
            return Promise.resolve(true);
        }
        else {
            return Promise.resolve(false);
        }
    };
    WebOSPlayer.prototype.nativeSetAudioTrackLunaApi = function (language) {
        var _this = this;
        var audioTrackIndex = this.availableAudioTracks.findIndex(function (track) { return track.language === language; });
        if (audioTrackIndex === -1) {
            return Promise.resolve(false);
        }
        return new Promise(function (resolve) {
            _this.context.webOS.service.request('luna://com.webos.media', {
                method: 'selectTrack',
                parameters: { type: 'audio', index: audioTrackIndex, mediaId: _this.videoElement.mediaId },
                onSuccess: function () {
                    resolve(true);
                },
                onFailure: function () {
                    _this.notifyWarning('NATIVE_AUDIO_TRACK_API', 'Cannot set audio track with luna media API.');
                    resolve(false);
                },
            });
        });
    };
    WebOSPlayer.prototype.hasAudioTracksFromSourceInfo = function (sourceInfo) {
        return sourceInfo && (sourceInfo.info.numPrograms > 0 || sourceInfo.info.programInfo[0].numAudioTracks > 0);
    };
    WebOSPlayer.prototype.getDuration = function () {
        return isNaN(this.videoElement.duration) || !this.videoElement.duration ? 0 : Math.round(this.videoElement.duration);
    };
    WebOSPlayer.prototype.loadAsset = function (nativeLoadData) {
        this.suppressNextPlayEvent = false;
        this.createSourceElement(nativeLoadData.cdn.url, nativeLoadData.position);
        this.addVideoListeners();
        this.videoElement.load();
    };
    WebOSPlayer.prototype.removeVideoListeners = function () {
        this.videoElement.removeEventListener('loadstart', this.onLoadStartHandler);
        this.videoElement.removeEventListener('playing', this.onPlayingHandler);
        this.videoElement.removeEventListener('error', this.onVideoErrorHandler);
        this.videoElement.removeEventListener('pause', this.onPauseHandler);
        this.videoElement.removeEventListener('waiting', this.onWaitingHandler);
        this.videoElement.removeEventListener('ended', this.onFinishHandler);
        this.videoElement.removeEventListener('timeupdate', this.onTimeUpdateHandler);
        this.videoElement.removeEventListener('durationchange', this.onDurationChangeHandler);
        this.videoElement.removeEventListener('umsmediainfo', this.onMediaInfoUpdateHandler);
        this.videoElement.removeEventListener('loadeddata', this.onLoadedData);
        this.videoElement.removeEventListener('loadedmetadata', this.onLoadedMetaData);
        this.videoElement.removeEventListener('stalled', this.onStalled);
    };
    WebOSPlayer.prototype.addVideoListeners = function () {
        this.videoElement.addEventListener('loadstart', this.onLoadStartHandler);
        this.videoElement.addEventListener('playing', this.onPlayingHandler);
        this.videoElement.addEventListener('error', this.onVideoErrorHandler);
        this.videoElement.addEventListener('pause', this.onPauseHandler);
        this.videoElement.addEventListener('waiting', this.onWaitingHandler);
        this.videoElement.addEventListener('ended', this.onFinishHandler);
        this.videoElement.addEventListener('timeupdate', this.onTimeUpdateHandler);
        this.videoElement.addEventListener('durationchange', this.onDurationChangeHandler);
        this.videoElement.addEventListener('umsmediainfo', this.onMediaInfoUpdateHandler, false);
        this.videoElement.addEventListener('loadeddata', this.onLoadedData);
        this.videoElement.addEventListener('loadedmetadata', this.onLoadedMetaData);
        this.videoElement.addEventListener('stalled', this.onStalled);
    };
    WebOSPlayer.prototype.createVideoElement = function (nativeLoadData) {
        if (this.videoElementWrapper) {
            return;
        }
        this.videoElementWrapper = this.context.document.createElement('div');
        this.videoElementWrapper.setAttribute('id', exports.PLAYER_ELEMENT_ID + "-wrapper");
        this.videoElement = this.context.document.createElement('video');
        this.videoElement.setAttribute('id', exports.PLAYER_ELEMENT_ID);
        if (nativeLoadData.autoplay && !this.isWebOS2) {
            this.videoElement.setAttribute('autoplay', 'auto');
        }
        this.videoElementWrapper.appendChild(this.videoElement);
        this.context.document.body.appendChild(this.videoElementWrapper);
    };
    WebOSPlayer.prototype.createSourceElement = function (source, startPosition) {
        if (this.sourceElement) {
            this.destroySourceElement();
        }
        var mediaOption = {
            htmlMediaOption: {
                useUMSMediaInfo: true,
            },
            option: {
                drm: {
                    type: 'playready',
                    clientId: this.drmAgent.clientId,
                },
                adaptiveStreaming: {
                    bps: {
                        start: this.startingBitrate,
                    },
                },
                transmission: {
                    playTime: {
                        start: startPosition && !this.isWebOS2 ? startPosition * 1000 : 0,
                    },
                },
            },
        };
        var promoRegex = /.mp4(\/?\?.*)?$/;
        this.sourceElement = this.context.document.createElement('source');
        this.sourceElement.setAttribute('src', source);
        if (promoRegex.test(source)) {
            this.sourceElement.setAttribute('type', 'video/mp4');
        }
        else {
            this.sourceElement.setAttribute('type', "application/vnd.ms-sstr+xml;mediaOption=" + escape(JSON.stringify(mediaOption)));
        }
        this.sourceElement.setAttribute('autobuffer', '');
        this.sourceElement.setAttribute('preload', '');
        this.videoElement.appendChild(this.sourceElement);
    };
    WebOSPlayer.prototype.getFirstAvailableTrackId = function (audioTracks) {
        var defaultAudioLanguage = this.nativeLoadData.defaultAudioLanguage;
        if (Array.isArray(defaultAudioLanguage)) {
            return defaultAudioLanguage.find(function (language) { return audioTracks.find(function (track) { return track.language === language; }) !== undefined; });
        }
        else {
            return defaultAudioLanguage;
        }
    };
    WebOSPlayer.prototype.setAudioTrackAfterLoaded = function () {
        return __awaiter(this, void 0, void 0, function () {
            var audioTracks;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getAudioTracks()];
                    case 1:
                        audioTracks = _a.sent();
                        if (audioTracks && audioTracks.length) {
                            this.notifyAvailableAudioTracksChanged(audioTracks);
                            return [2, this.setDefaultAudioTrack(audioTracks)];
                        }
                        else {
                            return [2, Promise.resolve()];
                        }
                        return [2];
                }
            });
        });
    };
    WebOSPlayer.prototype.setDefaultAudioTrack = function (tracks) {
        return __awaiter(this, void 0, void 0, function () {
            var defaultTrackId, success;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        defaultTrackId = this.getFirstAvailableTrackId(tracks);
                        if (!defaultTrackId) return [3, 2];
                        return [4, this.changeAudioTrack(defaultTrackId)];
                    case 1:
                        success = _a.sent();
                        if (success) {
                            this.notifyCurrentAudioTrackChanged(defaultTrackId);
                        }
                        else {
                            this.notifyCurrentAudioTrackChanged(tracks[0].trackId);
                        }
                        return [3, 3];
                    case 2:
                        if (tracks[0]) {
                            this.notifyCurrentAudioTrackChanged(tracks[0].trackId);
                        }
                        _a.label = 3;
                    case 3: return [2, Promise.resolve()];
                }
            });
        });
    };
    WebOSPlayer.prototype.getAudioTracksFromMediaInfo = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var owner = {};
            _this.mediaInfoAudioTracksObservable.registerObserver(function (tracks) {
                _this.mediaInfoAudioTracksObservable.unregisterObservers(owner);
                clearTimeout(timeout);
                resolve(tracks);
            }, owner);
            var timeout = setTimeout(function () {
                _this.mediaInfoAudioTracksObservable.unregisterObservers(owner);
                resolve([]);
            }, MAX_WAIT_AUDIOTRACKS_MS);
        });
    };
    WebOSPlayer.prototype.getAudioTracks = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isHtmlAudioTracksAvailable()) return [3, 1];
                        return [2, Array.from(this.videoElement.audioTracks).map(this.transformAudioTrack)];
                    case 1:
                        _a = this;
                        return [4, this.getAudioTracksFromMediaInfo()];
                    case 2:
                        _a.availableAudioTracks = _b.sent();
                        return [2, Array.from(this.availableAudioTracks).map(this.transformAudioTrack)];
                }
            });
        });
    };
    WebOSPlayer.prototype.isHtmlAudioTracksAvailable = function () {
        return this.videoElement.audioTracks && this.videoElement.audioTracks.length;
    };
    WebOSPlayer.prototype.transformAudioTrack = function (track) {
        return {
            language: track.language,
            trackId: track.language,
        };
    };
    WebOSPlayer.prototype.destroySourceElement = function () {
        this.videoElement.removeChild(this.sourceElement);
        this.sourceElement = null;
    };
    WebOSPlayer.prototype.destroyVideoElement = function () {
        this.context.document.body.removeChild(this.videoElementWrapper);
        this.videoElementWrapper = null;
        this.videoElement = null;
    };
    return WebOSPlayer;
}(client_lib_js_player_addons_common_player_1.Player));
exports.WebOSPlayer = WebOSPlayer;
